// import React, { useState, useRef, useCallback } from "react";
// import { LoadScript, StandaloneSearchBox } from "@react-google-maps/api";

// const libraries = ["places"];

// const GooglePlacesInput = () => {
//   const [address, setAddress] = useState("");
//   const [coordinates, setCoordinates] = useState(null);
//   const searchBoxRef = useRef(null);

//   const onLoad = ref => {
//     searchBoxRef.current = ref;
//   };

//   const onPlacesChanged = () => {
//     const places = searchBoxRef.current.getPlaces();
//     if (places.length === 0) return;

//     const place = places[0];
//     setAddress(place.formatted_address);

//     const location = place.geometry.location;
//     setCoordinates({
//       lat: location.lat(),
//       lng: location.lng(),
//     });
//   };

//   return (
//     <LoadScript
//       googleMapsApiKey="AIzaSyD6vYIY9m7lBCWFjNIMictpt0zMIjwhJTQ"
//       libraries={libraries}
//     >
//       <StandaloneSearchBox
//         onLoad={onLoad}
//         onPlacesChanged={onPlacesChanged}
//       >
//         <input
//           type="text"
//           placeholder="Enter an address"
//           style={{ width: 300, height: 40, padding: "0 12px" }}
//         />
//       </StandaloneSearchBox>

//       {address && (
//         <div style={{ marginTop: 20 }}>
//           <h3>Selected Address:</h3>
//           <p>{address}</p>
//           <p>Latitude: {coordinates.lat}</p>
//           <p>Longitude: {coordinates.lng}</p>
//         </div>
//       )}
//     </LoadScript>
//   );
// };

// export default GooglePlacesInput;



import React, { useState, useRef, useEffect } from "react";
import { LoadScript, StandaloneSearchBox } from "@react-google-maps/api";

const libraries = ["places"];

const GooglePlacesInput = ({
  location = null,
  onUpdated = () => {},
  manualInput = false,
  allowManualInput = false,
  requirePostalCode = false,
  placeholder = "Type your address",
  className = "form-control",
}) => {
  // State for input value & structured data
  const [search, setSearch] = useState("");
  const [data, setData] = useState(location || {});
  const [isManual, setIsManual] = useState(manualInput);
  const [errors, setErrors] = useState([]);

  const searchBoxRef = useRef(null);

  useEffect(() => {
    if (location) {
      setData(location);
      setSearch(location.raw || "");
    }
  }, [location]);

  const onLoad = (ref) => {
    searchBoxRef.current = ref;
  };

  const validate = (dataToValidate) => {
    let requiredFields = ["line_1", "city", "state", "country"];
    if (requirePostalCode) requiredFields.push("postal_code");

    const newErrors = requiredFields
      .filter((key) => !dataToValidate[key] || dataToValidate[key].trim() === "")
      .map((key) => ({
        key,
        message: `${key.replace(/_/g, " ")} is required`,
      }));
    setErrors(newErrors);
    return newErrors.length === 0;
  };

  const onPlacesChanged = () => {
    const places = searchBoxRef.current.getPlaces();
    if (!places || places.length === 0) return;

    const place = places[0];
    const loc = place.geometry.location;

    // Parse the address components
    const newData = {
      raw: place.formatted_address,
      latitude: loc.lat(),
      longitude: loc.lng(),
      line_1: "",
      line_2: "",
      city: "",
      state: "",
      country: "",
      postal_code: "",
      address_type:"Venue"
    };

    // Basic line_1/line_2 from formatted_address parts
    const parts = newData.raw.split(", ");
    if (parts.length > 0) newData.line_1 = parts[0];
    if (parts.length > 1) newData.line_2 = parts[1];

    place.address_components.forEach((component) => {
      const types = component.types;
      if (types.includes("locality") || types.includes("postal_town")) {
        newData.city = component.long_name;
      }
      if (types.includes("administrative_area_level_1")) {
        newData.state = component.long_name;
      }
      if (types.includes("country")) {
        newData.country = component.long_name;
        newData.country_short = component.short_name;
      }
      if (types.includes("postal_code")) {
        newData.postal_code = component.long_name;
      }
    });

    // Fallback: if no state, use city
    if (!newData.state) newData.state = newData.city;

    setData(newData);
    setSearch(newData.raw);
    setErrors([]);

    onUpdated(newData);
  };

  const handleManualChange = (e) => {
    const { name, value } = e.target;
    const updatedData = { ...data, [name]: value };

    // Rebuild raw address string from lines + city + state + country
    const rawParts = [updatedData.line_1, updatedData.line_2, updatedData.city, updatedData.state, updatedData.country]
      .filter(Boolean)
      .join(", ");
    updatedData.raw = rawParts;

    setData(updatedData);
    setSearch(updatedData.raw);

    // Validate on every manual change
    validate(updatedData);

    onUpdated(updatedData);
  };

  if (isManual) {
    return (
      <div>
        <input
          name="line_1"
          placeholder="Address Line 1"
          value={data.line_1 || ""}
          onChange={handleManualChange}
          className={className}
        />
        <input
          name="line_2"
          placeholder="Address Line 2 (Optional)"
          value={data.line_2 || ""}
          onChange={handleManualChange}
          className={className}
        />
        <input
          name="city"
          placeholder="City"
          value={data.city || ""}
          onChange={handleManualChange}
          className={className}
        />
        <input
          name="state"
          placeholder="State / Province"
          value={data.state || ""}
          onChange={handleManualChange}
          className={className}
        />
        <input
          name="country"
          placeholder="Country"
          value={data.country || ""}
          onChange={handleManualChange}
          className={className}
        />
        {requirePostalCode && (
          <input
            name="postal_code"
            placeholder="Postal Code"
            value={data.postal_code || ""}
            onChange={handleManualChange}
            className={className}
          />
        )}

        {errors.length > 0 && (
          <ul style={{ color: "red", marginTop: 4 }}>
            {errors.map((err) => (
              <li key={err.key}>{err.message}</li>
            ))}
          </ul>
        )}

        {allowManualInput && (
          <button onClick={() => setIsManual(false)} style={{ marginTop: 8 }}>
            Use Google Places Autocomplete
          </button>
        )}
      </div>
    );
  }

  return (
    <LoadScript googleMapsApiKey={process.env.REACT_APP_GMAPS_KEY} libraries={libraries}>
      <StandaloneSearchBox onLoad={onLoad} onPlacesChanged={onPlacesChanged}>
        <input
          type="text"
          placeholder={placeholder}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className={className}
          autoComplete="off"
          style={{ width: "100%", height: 40, padding: "0 12px" }}
        />
      </StandaloneSearchBox>

      {allowManualInput && (
        <button
        className="btn btn-primary font-weight-bolder px-4 py-2 "
        onClick={() => setIsManual(true)} style={{ marginTop: 8 }}>
          Enter Address Manually
        </button>
      )}

      {errors.length > 0 && (
        <ul style={{ color: "red", marginTop: 4 }}>
          {errors.map((err) => (
            <li key={err.key}>{err.message}</li>
          ))}
        </ul>
      )}
    </LoadScript>
  );
};

export default GooglePlacesInput;
